import Step1 from "../../../assets/imgs/job-placement/step1.png";
import Step2 from "../../../assets/imgs/job-placement/step2.png";
import Step3 from "../../../assets/imgs/job-placement/step3.png";
import Step4 from "../../../assets/imgs/job-placement/step4.png";
import Step5 from "../../../assets/imgs/job-placement/step5.png";

import Step1_1 from "../../../assets/imgs/job-placement/step1_1.png";
import Step1_2 from "../../../assets/imgs/job-placement/step1_2.png";
import Step1_3 from "../../../assets/imgs/job-placement/step1_3.png";
import Step1_4 from "../../../assets/imgs/job-placement/step1_4.png";
import Step1_5 from "../../../assets/imgs/job-placement/step1_5.png";


export const DATA = [
  {
    imgURL: Step1,
    imgURL2: Step1_1,
  },
  {
    imgURL: Step2,
    imgURL2: Step1_2,
  },
  {
    imgURL: Step3,
    imgURL2: Step1_3,
  },
  {
    imgURL: Step4,
    imgURL2: Step1_4,
  },
  {
    imgURL: Step5,
    imgURL2: Step1_5,
  },
];
